import styles from "./Dropdown.module.scss";

export const checkSelectedOptions = (values, option) => {
  return values.map((item) => item.value).includes(option.value);
};

export const CustomDropdownRenderer = ({ props, state, methods }) => {
  const regexp = new RegExp(state.search, "i");
  return (
    <div className={styles.customDropdownRender}>
      <div className={styles.buttonWrapper}>
        {methods.areAllSelected() ? (
          <button className="clear" onClick={methods.clearAll}>
            Clear all
          </button>
        ) : (
          <button onClick={methods.selectAll}>Select all</button>
        )}
      </div>
      <div className={styles.optionWrapper}>
        {props.options
          .filter((item) =>
            regexp.test(item[props.searchBy] || item[props.labelField])
          )
          .map((option) => {
            if (!props.keepSelectedInList && methods.isSelected(option)) {
              return null;
            }

            return (
              <div
                className={styles.option}
                disabled={option.disabled}
                key={option[props.valueField]}
                onClick={option.disabled ? null : () => methods.addItem(option)}
                style={{
                  ...(checkSelectedOptions(state.values, option) && {
                    background: "#E5F2FF",
                  }),
                }}
              >
                <label>{option[props.labelField]}</label>
                <input
                  type="checkbox"
                  onChange={() =>
                    option.disabled ? undefined : methods.addItem(option)
                  }
                  checked={checkSelectedOptions(state.values, option)}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};
